import React, { useEffect, useRef } from 'react'
import { Button, Input } from '@mui/material'
import { CloudUpload } from '@mui/icons-material'
import { Box } from '@mui/system'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'

export interface SmartMeterFileProps {
  file: Blob | null
  fileName: string
}

interface SmartMeterUploadProps {
  selectedFile: SmartMeterFileProps
  onFileChange: (file: SmartMeterFileProps) => void
}

const MAX_FILE_SIZE = 5 * 1000 * 1000

/*
 * This component shows the upload input field button for smartmeters
 */
const SmartMeterUpload: React.FC<SmartMeterUploadProps> = ({ selectedFile, onFileChange }) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const { enqueueErrorStack } = useSnackbar()
  const { t } = useCustomTranslation()

  useEffect(() => {
    if (selectedFile.file === null) {
      if (inputRef.current) {
        inputRef.current.value = ''
      }
    }
  }, [selectedFile])

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedFile = event.target.files?.[0]
    if (selectedFile) {
      if (selectedFile.size > MAX_FILE_SIZE) {
        return enqueueErrorStack(t('shop.smart-meter-document.file-too-large'))
      }
      const contract = { file: selectedFile, fileName: selectedFile.name } as SmartMeterFileProps
      onFileChange(contract)
    }
  }

  return (
    <Box>
      <Button component="label" variant={selectedFile.fileName ? 'contained' : 'outlined'} startIcon={<CloudUpload />}>
        {selectedFile.fileName || t('shop.smart-meter-document.upload-file-label')}
        <Input inputRef={inputRef} type="file" inputProps={{ accept: 'application/pdf' }} onChange={handleFileChange} sx={{ display: 'none' }} />
      </Button>
    </Box>
  )
}

export default SmartMeterUpload
